import Images from "../../../Images"
import { paymentMethodsImages } from "./paymentMethods"

/**
 * Get card type options with theme-aware icons
 * @param {string} theme - Current theme ('dark' or 'light')
 * @returns {Array} Array of card type options
 */
export const getCardOptionsForReasonCodes = (theme) => {
  const themeSuffix = theme === "dark" ? "_dark" : ""
  return [
    { id: "visa", name: "Visa", flag: Images?.["visa" + themeSuffix] },
    { id: "mastercard", name: "Mastercard", flag: Images?.["mastercard" + themeSuffix] },
    { id: "american express", name: "American Express", flag: Images?.["amex" + themeSuffix] },
    { id: "discover", name: "Discover", flag: Images?.["discover" + themeSuffix] },
    { id: "cash app pay", name: "Cash App Pay", flag: paymentMethodsImages["Cash App"] },
    { id: "paypal", name: "PayPal", flag: paymentMethodsImages["PayPal"] },
    { id: "klarna", name: "Klarna", flag: paymentMethodsImages["Klarna"] }
  ]
}

export const cardBrandToTextMap = {
  visa: "Visa",
  mastercard: "Mastercard",
  "american express": "American Express",
  amex: "Amex",
  discover: "Discover",
  link: "LINK",
  paypal: "PayPal",
  "japan credit bureau": "Japan Credit Bureau",
  jcb: "Japan Credit Bureau",
  unionpay: "Union Pay",
  "diners club international": "Diners Club International",
  maestro: "Maestro",
  bogus: "Bogus",
  cartes_bancaires: "Cartes Bancaires",
  fdtre: "FDTRE",
  interac: "Interac"
}
